import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'

const TYPE_KEYS: Record<ComponentProgressDetailView['type'], string> = {
  video: 'notStarted.video',
  quiz: 'notStarted.quiz',
  guide: 'notStarted.guide',
  toon: 'notStarted.toon',
  assignment: 'notStarted.assignment',
  interactive: 'notStarted.interactive',
  buildup: 'notStarted.buildup',
  warmup: 'notStarted.warmup',
}

interface Props {
  type: ComponentProgressDetailView['type']
}

export function NotStartedFallback({ type }: Props) {
  const { t } = useTranslation('coaching')
  return (
    <div className="rounded-lg bg-gray-50 border border-gray-200 p-6 text-center text-sm text-gray-600">
      {t(TYPE_KEYS[type], t('notStarted.default'))}
    </div>
  )
}
